import { EmptyActionsBlock } from "designSystem/EmptyContentBlocks/EmptyActionsBlock";
import { inject, observer } from "mobx-react";
import React from "react";
import { pipe } from "Utils/functionalUtils";
import Actions from "./Actions";

const ActionsRedirector = (props) => {
	const {
		operatorForCard: {
			info: { cnt_action_tariffs, cnt_news },
		},
		ApplicationModel: { text },
	} = props;

	if (!cnt_action_tariffs && !cnt_news) {
		return <EmptyActionsBlock text={text} redirectTo={"ratesmobile"} />;
	}

	return <Actions {...props} />;
};

export default pipe(observer, inject("ApplicationModel"))(ActionsRedirector);
